module.exports = __webpack_public_path__ + "img/tmlab.695cb002.png";